<template>
  <filedInput
    v-model="item"
    v-bind="$attrs"
    :class="className"
    clearable
    :defaultInput="defaultInput"
    dense
    :hideDetails="hideDetails"
    :label="noLabel ? '' : label"
    :outlined="outlined"
    :placeholder="placeholder"
    prepend-inner-icon="mdi-magnify"
    :typeInput="typeInput"
    v-on="$listeners"
    @click:clear="item = ''"
  ></filedInput>
</template>

<script>
import filedInput from './field-input.vue'
export default {
  inheritAttrs: false,
  components: { filedInput },
  props: {
    outlined: { type: Boolean, default: true },
    placeholder: { type: String, default: 'Nhập để tìm kiếm' },
    noLabel: { type: Boolean, default: true },
    label: { type: String, default: 'Tìm kiếm' },
    value: {},
    typeInput: { type: String, default: 'v-text-field' },
    defaultInput: { type: Boolean, default: false },
    hideDetails: { type: String, default: 'auto' },
    className: String,
  },
  data: () => ({}),
  watch: {},
  computed: {
    item: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  filters: {},
  methods: {},
}
</script>

<style lang="scss" scoped></style>
